exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.kpi-card[data-v-319340c3] {\n\twidth: 100%;\n\tfont-weight: bold;\n\tpadding: 0;\n}\n.kpi-card-body[data-v-319340c3] {\n\tpadding: 2rem 0;\n}\n.kpi-card-body span[data-v-319340c3] {\n\tcolor: #007949;\n}\n.kpi-card-body strong[data-v-319340c3] {\n\tdisplay: block;\n\tfont-size: 32px;\n\tfont-weight: normal;\n}\n", ""]);

// exports
